export const FEATURES = {
  basic: [
    { icon: 'ten-score', text: 'plans.basic.features.tenScores', iconFontSize: 'text-[28px]' },
    { icon: 'note', text: 'plans.basic.features.basicTools' },
    { icon: 'share-alt', text: 'plans.basic.features.share' },
    { icon: 'community', text: 'plans.basic.features.groups', iconFontSize: 'text-[18px]' },
  ],
  premium: (showAds: boolean) => [
    {
      icon: 'hal',
      text: 'plans.premium.features.halTitles',
      iconFontSize: 'text-[28px]',
      tag: { text: 'plans.premium.features.halTitles_tag', className: 'bg-orange' },
    },
    {
      icon: 'unlimited-score',
      text: 'plans.premium.features.unlimitedScores',
      iconFontSize: 'text-[28px]',
    },
    {
      icon: 'premium-notation',
      text: 'plans.premium.features.premiumTools',
      iconFontSize: 'text-h3',
    },
    {
      icon: 'parts',
      text: 'plans.premium.features.instruments',
      iconFontSize: 'text-h3',
    },
    {
      icon: 'transcribe',
      text: 'plans.premium.features.transcribe',
      iconFontSize: 'text-[25px]',
    },
    { icon: 'mixer', text: 'plans.premium.features.audio', iconFontSize: 'text-h3' },
    ...(showAds
      ? [{ icon: 'no-ads', text: 'plans.premium.features.adFree', iconFontSize: 'text-[28px]' }]
      : []),
    { icon: 'arrangeme', text: 'plans.premium.features.arrangeMe' },
    { icon: 'share-alt', text: 'plans.premium.features.share' },
    { icon: 'community', text: 'plans.premium.features.groups', iconFontSize: 'text-[18px]' },
  ],
  edu: [
    {
      icon: 'lock-thin',
      text: 'plans.edu.features.privacy',
      description: 'plans.edu.features.privacy_desc',
      iconFontSize: 'text-h3',
    },
    {
      icon: 'premium-notation',
      text: 'plans.edu.features.notation',
      description: 'plans.edu.features.notation_desc',
      iconFontSize: 'text-h3',
    },
    {
      icon: 'assignment',
      text: 'plans.edu.features.assignments',
      description: 'plans.edu.features.assignments_desc',
      iconFontSize: 'text-[28px]',
    },
    {
      icon: 'organize',
      text: 'plans.edu.features.organize',
      description: 'plans.edu.features.organize_desc',
      iconFontSize: 'text-[28px]',
    },
    {
      icon: 'community',
      text: 'plans.edu.features.sync',
      description: 'plans.edu.features.sync_desc',
      iconFontSize: 'text-[18px]',
    },
    {
      icon: 'hal',
      text: 'plans.edu.features.halTitles',
      description: 'plans.edu.features.halTitles_desc',
      iconFontSize: 'text-[28px]',
      tag: { text: 'plans.edu.features.halTitles_tag', className: 'bg-green' },
    },
    {
      icon: 'chart',
      text: 'plans.edu.features.soundcheck',
      description: 'plans.edu.features.soundcheck_desc',
      iconFontSize: 'text-h3',
      tag: { text: 'plans.edu.features.soundcheck_tag', className: 'bg-green' },
    },
  ],
}
